import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '',
        loadComponent: () => import('./public-signup.component').then(m => m.PublicSignupComponent),
        data: {
          title: 'KudosHub | Register',
          description:'New Customer? Start Here. Create your KudosHub account to enjoy our digital marketing services. Type in your email and password and click Next.',
          keywords: 'kudoshub register, create a free account, free signup, kudoshub signup',
          ogTitle: 'KudosHub | Register',
          ogDesc: 'Kudoshub register page.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/register-image1.webp',
          ogUrl: 'https://kudoshub.com/register',
          twitterTitle: 'KudosHub | Register',
          twitterDesc: 'Kudoshub register page.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/register-image1.webp'
        }
      }
    ]
  }
];

// @NgModule({
//   imports: [RouterModule.forChild(routes)],
//   exports: [RouterModule]
// })
// export class PublicSignupRoutingModule { }
